var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-deployment-image",style:(_vm.isClick ? 'cursor:pointer': ''),on:{"click":_vm.emitToClick}},[_c('div',{class:['selected-point', {'pulse-effect': _vm.isBallPulse}],style:({width: _vm.sizeBall + 'px', height: _vm.sizeBall + 'px'})},[_c('div',{staticClass:"point-value",style:({
                'background': _vm.setColor.color
            })},[_c('span',{staticClass:"value",style:({
                    'color': _vm.getContrastColor(_vm.setColor.color),
                    'font-size': _vm.sizeBall*0.40 + 'px'
                })},[_vm._v(" "+_vm._s(_vm.data.number)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }